export default __webpack_public_path__ + "static/media/external-house-icon.4d20d698.svg";